import { createStore } from 'vuex'

export default createStore({
  state: {
    accepted: false
  },
  mutations: {
    setAccepted(state, payload) {
      state.accepted = payload;
    }
  },
  actions: {
    updateAccepted({ commit }, payload) {
      commit('setAccepted', payload);
    }
  },
  getters: {
    accepted(state) {
      return state.accepted;
    }  },
  modules: {
  }
})
